import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export const TourOrderConfirmCheck = ({ visible = true }) => {
  const checkRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!checkRef.current && visible) {
      checkRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }
  }, [checkRef, visible]);

  if (!visible) {
    return null;
  }

  return (
    <div className="order-confirmation__complete-check" ref={checkRef}>
      <span className="order-confirmation__complete-icon">
        <FontAwesomeIcon icon={faCheckCircle} />
      </span>
    </div>
  );
};

export default TourOrderConfirmCheck;
